<template>
  <NuxtLoadingIndicator style="position: sticky;" />
  <div class="h-100 max-height">
    <slot />
  </div>
</template>
